import { ChangeDetectionStrategy, Component } from '@angular/core';

import { InfoApiService } from '@atmi/core';
import { RoleService } from '@sim/role';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-home',
  styleUrls: ['./home.component.scss'],
  templateUrl: './home.component.html',
})
export class HomeComponent {

  readonly systemInfo$ = this.infoApi.systemInfo();

  readonly isAdmin$ = this.roleService.isAdmin();

  constructor(
    private readonly infoApi: InfoApiService,
    private readonly roleService: RoleService,
  ) {
  }
}
